export default __webpack_public_path__ + "static/media/expoindo-7.a3787dd0.jpg";